// extracted by mini-css-extract-plugin
export default {"user-avatar":"_1n13v","userAvatar":"_1n13v","pixelated":"_3hdOZ"};